export const RECEIVE_DATA = 'NETWORTHDONUTCHART.RECEIVE_DATA';
export const SET_TYPE = 'NETWORTHDONUTCHART.SET_TYPE';

export const receive_data = (chart_type, resp_data, clientId) => ({
  type: RECEIVE_DATA,
  chart_type,
  resp_data,
  clientId,
});
